import { action } from 'src/store/actions';

export const FETCH_ORDERING_NOTE_SUBJECTS = 'FETCH_ORDERING_NOTE_SUBJECTS';
export const REQUEST_ORDERING_NOTE_SUBJECTS = 'REQUEST_ORDERING_NOTE_SUBJECTS';
export const SUCCESS_ORDERING_NOTE_SUBJECTS = 'SUCCESS_ORDERING_NOTE_SUBJECTS';
export const FAILURE_ORDERING_NOTE_SUBJECTS = 'FAILURE_ORDERING_NOTE_SUBJECTS';

export const fetchOrderingNoteSubjects = () => action(FETCH_ORDERING_NOTE_SUBJECTS);
export const requestOrderingNoteSubjects = () => action(REQUEST_ORDERING_NOTE_SUBJECTS);
export const requestOrderingNoteSubjectsSuccess = (response: any) =>
    action(SUCCESS_ORDERING_NOTE_SUBJECTS, { response });
export const requestOrderingNoteSubjectsFailure = (error: any) => action(FAILURE_ORDERING_NOTE_SUBJECTS, { error });
